import { render, staticRenderFns } from "./page-loader.vue?vue&type=template&id=6837908f&scoped=true"
import script from "./page-loader.vue?vue&type=script&lang=js"
export * from "./page-loader.vue?vue&type=script&lang=js"
import style0 from "./page-loader.vue?vue&type=style&index=0&id=6837908f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6837908f",
  null
  
)

export default component.exports